<style lang="scss" scoped>
.edit-pwd {
  .error-msg {
    color: #e0563d;
    font-size: 12px;
    left: 0;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
  }

  .pwd-icon {
    font-size: 20px;
    padding-top: 3px;

    &__loading {
      bottom: -15px;
      position: absolute;
    }
  }

  .warning-msg-wrapper {
    margin-right: -80px;
    text-align: center;
    @media screen and (max-device-width: 400px) {
      margin-right: 0;
      text-align: left !important;
    }
  }

  .warning-msg {
    background: #fef4e5;
    border: 1px solid #fce5c0;
    display: inline-block;
    font-size: 12px;
    margin-bottom: 32px;
    padding: 6px 16px;
    text-align: center;
    @media screen and (max-device-width: 400px) {
      text-align: left;
    }

    .iconfont {
      color: #f39800;
      font-size: 24px;
      margin-right: 10px;
      vertical-align: middle;
    }

    .before {
      color: #515152;
      vertical-align: middle;
    }

    .after {
      color: #f38500;
      margin-left: 3px;
      vertical-align: middle;
    }
  }

  .cursor {
    cursor: pointer;
  }
}
</style>
<style lang="scss">
/* stylelint-disable no-duplicate-selectors */
.edit-pwd {
  .el-input__suffix {
    right: 8px;
  }

  .el-form-item.error {
    margin-bottom: 24px;

    .el-input__inner {
      border-color: #e0563d;
    }
  }
}
</style>
<template>
  <el-form
    class="edit-pwd"
    ref="editPwdForm"
    :model="model"
    :rules="editPwdForRule"
    action="."
    label-width="180px"
    :label-position="labelPosition"
    style="margin-top: 16px"
  >
    <div class="warning-msg-wrapper">
      <div class="warning-msg">
        <i class="iconfont icon-jinggao_xingzhuang"></i>
        <span class="before" v-t="'i18n.editPwdWarningBefore'"></span>
        <span class="after" v-t="'i18n.editPwdWarningAfter'"></span>
      </div>
    </div>
    <el-form-item :label="$t('i18n.accountInfor')">
      <span class="account-infor-name">{{ currentUserInfo.userName }}</span>
      <span class="account-infor-name" style="margin-left: 32px">
        {{ accountInforName }}
      </span>
    </el-form-item>
    <el-form-item :label="$t('i18n.newPwd')" prop="newPwd" :error="errorMsg">
      <el-popover
        v-if="labelPosition === right"
        popper-class="app-rule-popover"
        ref="popover"
        placement="right"
        width="308"
        trigger="focus"
      >
        <div class="rule-infor">
          <p class="rule-infor__item" v-t="'rule.title'"></p>
          <p class="rule-infor__item" v-t="'rule.one'"></p>
          <p class="rule-infor__item" v-t="'rule.two'"></p>
          <p class="rule-infor__item" v-t="'rule.three'"></p>
          <p class="rule-infor__item" v-t="'rule.four'"></p>
          <p class="rule-infor__item" v-t="'rule.five'"></p>
        </div>
      </el-popover>
      <el-input
        onpaste="return false;"
        :type="newPwdType"
        v-focus
        v-model="model.newPwd"
        :placeholder="$t('i18n.newPwdPlaceholder')"
        v-popover:popover
      >
        <span slot="suffix" @click="pwdTypeChange('newPwdType')">
          <svg-i class="pwd-icon cursor" :icon="pwdIcon"></svg-i>
        </span>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('i18n.surePwd')" prop="pwdSure" :error="errorMsg">
      <el-input
        @keyup.13.native="$emit('keyup-submit')"
        onpaste="return false;"
        :type="pwdSureType"
        v-model="model.pwdSure"
        :placeholder="$t('i18n.surePwdPlaceholder')"
      >
        <span slot="suffix" @click="pwdTypeChange('pwdSureType')">
          <svg-i class="pwd-icon cursor" :icon="pwdSureIcon"></svg-i>
        </span>
      </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: "newPwd",
  props: {
    model: {
      type: Object,
    },
    currentUserInfo: {
      type: Object,
    },
    errorMsg: String,
  },
  data() {
    return {
      labelPosition: window.matchMedia("(min-width: 400px)").matches
        ? "right"
        : "top",
      newPwdType: "password",
      pwdSureType: "password",
    };
  },

  computed: {
    rule() {
      return this.$store.state.appCloudLayoutStore.rules;
    },
    editPwdForRule() {
      return {
        newPwd: [
          {
            required: true,
            message: this.$t("i18n.newPwdPlaceholder"),
            trigger: "blur",
          },
          { validator: this.newPwdValid, trigger: "blur" },
        ],
        pwdSure: [
          {
            required: true,
            message: this.$t("i18n.surePwdErrorMsg"),
            trigger: "blur",
          },
          { validator: this.validPwd, trigger: "blur" },
        ],
      };
    },
    pwdIcon() {
      return this.newPwdType === "password" ? "icon-biyan" : "icon-kaiyan";
    },
    pwdSureIcon() {
      return this.pwdSureType === "password" ? "icon-biyan" : "icon-kaiyan";
    },
    accountInforName() {
      if (this.currentUserInfo.domainAccount) {
        return `${this.currentUserInfo.domainAccount}@caocaoglobal.com`;
      }
      if (this.currentUserInfo.employeeNo) {
        return this.currentUserInfo.employeeNo;
      }
      return this.currentUserInfo.mobile;
    },
  },
  methods: {
    validPwd(rule, value, callback) {
      if (value !== this.model.newPwd) {
        callback(new Error(this.$t("i18n.pwdInconformity")));
      } else {
        callback();
      }
    },
    newPwdValid(rule, value, callback) {
      if (value.length < 8 || value.length > 16 || !/^\S+$/.test(value)) {
        callback(new Error(this.$t("i18n.newPwdUndesirable")));
      } else {
        this.$store.dispatch("appCloudLayoutStore/getPublicKey").then((res) => {
          if (res.code === "success") {
            this.$api.passwordupdate
              .validpassword(value)
              .then(() => {
                callback();
              })
              .catch((err) => {
                callback(new Error(this.$t(`ajax.${err.CODE || err.code}`)));
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        });
      }
    },
    pwdTypeChange(type) {
      this[type] = this[type] === "password" ? "text" : "password";
    },

    getValidResault(callback) {
      return this.$refs.editPwdForm.validate((valid) => {
        callback(valid);
      });
    },
  },
};
</script>
